import { createLocalStorage } from '@collector/shared-ui'

const SportsApiAccessToken = createLocalStorage('SportsAPI_access_token')

export { SportsApiAccessToken }
